import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Row, Col, Divider, Typography, Spin, Switch } from 'antd';
import { SettingOutlined, DollarOutlined, GiftOutlined, MessageOutlined } from '@ant-design/icons';
import { adminAPI } from '../services/api';

const { Title, Text } = Typography;

const SystemSettings = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getConfigs();
      if (response.code === 0) {
        setConfigs(response.data.list || []);
        // 设置表单值
        const formValues = {};
        response.data.list.forEach(config => {
          formValues[config.config_key] = config.config_value;
        });
        form.setFieldsValue(formValues);
      }
    } catch (error) {
      message.error('获取配置失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    setSaving(true);
    try {
      // 逐个更新配置
      for (const [key, value] of Object.entries(values)) {
        const config = configs.find(c => c.config_key === key);
        if (config && config.config_value !== value) {
          await adminAPI.updateConfig(config.id, value);
        }
      }
      message.success('保存成功');
      fetchConfigs();
    } catch (error) {
      message.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={4} style={{ marginBottom: 24 }}>
        <SettingOutlined style={{ marginRight: 8 }} />
        营销管理
      </Title>

      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={24}>
            <Col span={12}>
              <Card title={<><GiftOutlined /> 注册设置</>} style={{ marginBottom: 24 }}>
                <Form.Item
                  name="register_bonus"
                  label="新用户注册赠送余额（美元）"
                  rules={[{ required: true, message: '请输入注册赠送金额' }]}
                >
                  <Input type="number" step="0.01" min="0" prefix="$" />
                </Form.Item>
                <Text type="secondary">
                  新用户注册成功后自动赠送的余额金额
                </Text>
              </Card>
            </Col>

            <Col span={12}>
              <Card title={<><DollarOutlined /> 代理设置</>} style={{ marginBottom: 24 }}>
                <Form.Item
                  name="default_commission_rate"
                  label="默认佣金比例"
                  rules={[{ required: true, message: '请输入佣金比例' }]}
                >
                  <Input type="number" step="0.01" min="0" max="1" placeholder="0.1 表示 10%" />
                </Form.Item>
                <Form.Item
                  name="min_withdrawal"
                  label="最低提现金额（美元）"
                  rules={[{ required: true, message: '请输入最低提现金额' }]}
                >
                  <Input type="number" step="1" min="0" prefix="$" />
                </Form.Item>
                <Text type="secondary">
                  代理商推广用户消费后可获得的佣金比例，以及申请提现的最低金额
                </Text>
              </Card>
            </Col>
          </Row>

          <Divider />

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving} size="large">
              保存设置
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default SystemSettings;
